import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskFinish = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskFinish;
